// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.msg-body {
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.msg-body a {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/sem-messenger/sem-messenger.component.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".msg-body {\r\n    white-space: pre-wrap;\r\n    word-break: break-word;\r\n    overflow-wrap: anywhere;\r\n}\r\n\r\n.msg-body a {\r\n    text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
